import React from 'react';
import { View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { scale } from '@components/frame';
import { isPhone } from '@helpers';
import { getBoxShadowStyle } from '@styles/shadow';

import { MODAL_BORDER_RADIUS, MODAL_MIN_HEIGHT, MODAL_WIDTH } from '@components/tenantStatus/onboardingWizard/constants';
import type { WizardCardProps } from '@components/tenantStatus/onboardingWizard/types';

const WizardCard = ({ C, children, testID, cardTestID }: WizardCardProps) => {
  const insets = useSafeAreaInsets();

  return (
    <View
      testID={testID}
      style={{
        flex: 1,
        width: '100%',
        backgroundColor: C(isPhone ? 'Background/Light/Panel' : 'Background/Light/Detail'),
        justifyContent: 'center',
        alignItems: 'center',
        paddingHorizontal: isPhone ? 0 : scale(20),
        paddingVertical: isPhone ? 0 : scale(20),
      }}
    >
      <View
        testID={cardTestID}
        style={[
          {
            backgroundColor: C('Background/Light/Panel'),
            paddingHorizontal: scale(isPhone ? 20 : 40),
            paddingTop: isPhone ? scale(24) + insets.top : scale(36),
            paddingBottom: isPhone ? scale(24) + insets.bottom : scale(36),
          },
          isPhone
            ? { width: '100%', flex: 1 }
            : [
                {
                  width: scale(MODAL_WIDTH),
                  minHeight: scale(MODAL_MIN_HEIGHT),
                  borderRadius: scale(MODAL_BORDER_RADIUS),
                },
                getBoxShadowStyle({ type: 'Wide', C }),
              ],
        ]}
      >
        {children}
      </View>
    </View>
  );
};

export default WizardCard;
